import { render, staticRenderFns } from "./FileMgt.vue?vue&type=template&id=c7410724&scoped=true&"
import script from "./FileMgt.vue?vue&type=script&lang=js&"
export * from "./FileMgt.vue?vue&type=script&lang=js&"
import style0 from "./FileMgt.vue?vue&type=style&index=0&id=c7410724&scoped=true&lang=css&"
import style1 from "./FileMgt.vue?vue&type=style&index=1&id=c7410724&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7410724",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c7410724')) {
      api.createRecord('c7410724', component.options)
    } else {
      api.reload('c7410724', component.options)
    }
    module.hot.accept("./FileMgt.vue?vue&type=template&id=c7410724&scoped=true&", function () {
      api.rerender('c7410724', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sales/leads/Edit/FileMgt.vue"
export default component.exports